var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlue2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 449 86",
    xmlSpace: "preserve",
    width: 449,
    height: 86,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs73"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style42"
  }, "\r\n\t.st0{fill:#6933D6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 151.6,52.4 h -5.8 V 36.8 c -2.4,-0.3 -5.1,-0.5 -7.6,-0.5 -8.1,0 -10.4,1.8 -10.4,7.1 v 8.9 H 122 v -10 c 0,-1.5 0.2,-2.8 0.5,-3.9 -2.1,-1.3 -5,-2.1 -9.2,-2.1 -7.1,0 -9.4,1.8 -9.4,7.1 v 8.9 h -5.8 v -10 c 0,-7.6 4.8,-10.9 15,-10.9 5.6,0 9.6,1.3 12.1,3 2.5,-2 6.6,-3 12.5,-3 5.1,0 11.1,0.8 13.8,1.6 0.1,0.2 0.1,19.4 0.1,19.4 z",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 187.1,51.6 c -1.7,0.5 -7.8,1.6 -13.6,1.6 -12.4,0 -17,-3 -17,-10.9 0,-7.1 4.3,-10.9 15.9,-10.9 10.3,0 17.1,2.8 15.9,12.7 h -25.8 c 0.7,3.5 3.6,4.4 11,4.4 6.7,0 11.9,-0.8 13.6,-1.5 z m -4.5,-11.1 c 0,-3 -3.6,-4.3 -10.3,-4.3 -6.1,0 -9.1,1.1 -9.8,4.3 z",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 230.8,25.2 h 5.8 v 4.1 h -5.8 z m 0,7.3 h 5.8 v 19.9 h -5.8 z",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 270.5,49.8 c -2.6,2.3 -6,3.4 -12.6,3.4 -11,0 -15.6,-4.3 -15.6,-10.9 0,-6.5 4.7,-10.9 15.6,-10.9 6.1,0 12.7,0.6 18.4,1.6 v 19.2 h -5.8 z m -11.2,-1.3 c 8.5,0 11.2,-2.3 11.2,-6.9 v -4.4 c -1.5,-0.3 -5.9,-0.8 -11.2,-0.8 -8.2,0 -11.2,1.7 -11.2,6 0,4.2 3,6.1 11.2,6.1 z",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 282.4,25.2 h 5.8 v 6.9 c 3,-0.4 6.5,-0.6 8.9,-0.6 12.5,0 17.1,3 17.1,10.9 0,7.9 -4.6,10.9 -17.1,10.9 -4.3,0 -12.1,-0.8 -14.7,-1.6 z m 5.8,22.7 c 2.8,0.3 6.1,0.5 8.9,0.5 8.6,0 11.3,-1.5 11.3,-6 0,-4.6 -2.6,-6 -11.3,-6 -2.7,0 -6.1,0.2 -8.9,0.5 z",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 224.4,51.6 c -2.6,0.8 -10.3,1.6 -14.7,1.6 -12.5,0 -17.1,-3 -17.1,-10.9 0,-7.9 4.6,-10.9 17.1,-10.9 2.3,0 5.9,0.2 8.9,0.6 v -6.9 h 5.8 c 0,0.1 0,26.5 0,26.5 z m -5.8,-14.7 c -2.8,-0.3 -6.2,-0.5 -8.9,-0.5 -8.7,0 -11.3,1.5 -11.3,6 0,4.5 2.7,6 11.3,6 2.8,0 6.1,-0.2 8.9,-0.5 z",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 346.5,49.8 c -2.6,2.3 -6,3.4 -12.6,3.4 -11,0 -15.6,-4.3 -15.6,-10.9 0,-6.5 4.7,-10.9 15.6,-10.9 6.1,0 12.7,0.6 18.4,1.6 v 19.2 h -5.8 z m -11.2,-1.3 c 8.5,0 11.2,-2.3 11.2,-6.9 v -4.4 c -1.5,-0.3 -5.9,-0.8 -11.2,-0.8 -8.2,0 -11.2,1.7 -11.2,6 0,4.2 3,6.1 11.2,6.1 z",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 358.5,32.5 h 29.4 v 3.4 l -19.7,11.9 h 19.7 v 4.6 h -30.1 v -3.5 l 19.8,-11.8 h -19.1 z",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 420.7,49.8 c -2.6,2.3 -6,3.4 -12.6,3.4 -11,0 -15.6,-4.3 -15.6,-10.9 0,-6.5 4.7,-10.9 15.6,-10.9 6.1,0 12.7,0.6 18.4,1.6 v 19.2 h -5.8 z m -11.2,-1.3 c 8.5,0 11.2,-2.3 11.2,-6.9 v -4.4 c -1.5,-0.3 -5.9,-0.8 -11.2,-0.8 -8.2,0 -11.2,1.7 -11.2,6 -0.1,4.2 3,6.1 11.2,6.1 z",
    id: "path60"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 78.2,46 61.5,80.1 C 55.4,92 36.2,84 42.1,72 l 2.3,-4.8 C 45.9,64 45.5,60.4 43.8,57.7 42.2,55 39.3,53.2 35.9,53.1 h -3.4 c -0.6,0 -1.3,0 -1.9,0 C 21,53 18.2,43.7 22.4,37.8 L 24,34.4 c 1.5,-3.2 1.1,-6.8 -0.6,-9.5 -1.6,-2.7 -4.5,-4.5 -7.9,-4.6 H 10.3 C -4,20.2 -3.5,0 12.4,0 h 37.4 c 3.3,0 6,1.7 7.7,4.1 1.5,2.7 1.7,6.1 0.3,9.1 l -9.7,19.7 h 22.2 c 3.3,0 6,1.7 7.7,4.1 1.4,2.7 1.7,6 0.2,9 z",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 444.84663,24.772753 c 0.6,0.3 1.2,0.6 1.7,1 2.2,1.7 2.5,4 2,6.5 -0.5,2.6 -2.3,4.1 -4.9,4.6 -2.2,0.4 -4.2,0.2 -6.3,-0.9 0,1.9 0,3.7 0,5.6 -1.5,0 -2.9,0 -4.5,0 0,-0.3 0,-0.5 0,-0.8 0,-6.7 0,-13.3 0,-20 0,-3.9 2.8,-6.8 6.6,-7 1.8,-0.1 3.7,0 5.3,0.9 3.3,1.8 4.2,7.1 0.5,9.6 0,0.3 -0.2,0.4 -0.4,0.5 z m -5.5,-1.3 c 0.5,0 1,0 1.5,-0.1 1.3,-0.1 2.1,-0.9 2.3,-2.1 0.3,-1.7 -0.2,-3 -1.3,-3.6 -2,-1 -4.4,0.3 -4.4,2.6 0,3.9 0,7.9 0,11.8 0,0.2 0.2,0.6 0.4,0.7 1.2,0.6 2.5,0.8 3.9,0.5 1.8,-0.3 2.7,-1.7 2.5,-3.6 -0.2,-2 -1.3,-3 -3.2,-3.1 -0.5,0 -1.1,0 -1.6,0 -0.1,-1 -0.1,-2 -0.1,-3.1 z",
    id: "path66"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue2);
export default __webpack_public_path__ + "static/media/logo_blue2.c2ce755a1ea7a8d2a97368054a80ebd8.svg";
export { ForwardRef as ReactComponent };